import * as React from "react";
import { Redirect, useLocation } from "react-router-dom";
import { push } from "helpers/history";
import useUser from "hooks/useUser";
import showNotify from "helpers/notify";
import { Spin, Typography } from "antd";
// Styles
import styles from "./index.module.scss";

const { Title } = Typography;

const Home: React.FC = () => {
	const { aanLogin } = useUser();
	const location = useLocation();
	// A custom hook that builds on useLocation to parse
	// the query string for you.
	function useQuery() {
		return new URLSearchParams(location.search);
	}

	const query = useQuery();
	React.useEffect(() => {
		async function login() {
			if (query.get("payload")) {
				try {
					await aanLogin(query.get("payload"));
				} catch (error) {
					showNotify({ text: "توکن نامعتبر است." });
					push("/auth");
				}
			}
		}
		login();
	}, [query, aanLogin]);

	return query.get("payload") ? (
		<div className={styles["loading"]}>
			<Spin size="large" />
			<Title level={4}>
				در حال ورود به سامانه...
			</Title>
		</div>
	) : (
		<Redirect to="/auth" />
	);
};

export default Home;
